import { useContext } from "react";

import { ProjectLiveChatContext } from "./ProjectLiveChatContext";

export const useProjectLiveChat = () => useContext(ProjectLiveChatContext);
